﻿import DomNode from './node';

/*-----------------------------------------------
|   List Bulk Select
-----------------------------------------------*/

export class ListBulkSelect {
  constructor(list, options) {
    this.list = list;
    this.options = {
      displayNoneClassName: 'd-none',
      checkbox: '',
      actions: 'bulk-select-actions',
      replaced: 'bulk-select-replace',
      ...options
    };

    if (this.options.checkbox) {
      this.bulkCheckbox = document.getElementById(this.options.checkbox);
    } else {
      this.bulkCheckbox = list.listContainer.querySelector(
        'table thead input[type=checkbox]'
      );
    }
    this.actions = new DomNode(document.getElementById(this.options.actions));
    this.replaced = new DomNode(document.getElementById(this.options.replaced));

    const eventHandler = this.clickRowCheckbox.bind(this);

    this.list.on('updated', () => {
      const checkboxes = this.list.listContainer.querySelectorAll(
        '[data-bulk-select-checked]'
      );
      checkboxes.forEach(checkbox => {
        checkbox.checked =
          checkbox.getAttribute('data-bulk-select-checked') === 'checked';
        checkbox.addEventListener('click', eventHandler);
      });
    });

    this.clickBulkCheckbox();
  }

  getSelectedRows() {
    return Array.from(this.list.items)
      .filter(item => item.values().checked)
      .map(item => {
        try {
          return JSON.parse(item.values().select);
        } catch {
          return item.values().select;
        }
      });
  }

  clickBulkCheckbox() {
    // Handle click event in bulk checkbox
    this.bulkCheckbox.addEventListener('click', () => {
      this.toggleDisplay();

      // set check on all filter or search matches
      if (this.list.filtered || this.list.searched) {
        if (this.bulkCheckbox.checked) {
          this.bulkCheckbox.indeterminate = true;
          this.bulkCheckbox.setAttribute('indeterminate', 'indeterminate');
        } else {
          this.bulkCheckbox.indeterminate = false;
          this.bulkCheckbox.removeAttribute('indeterminate');
        }

        this.list.matchingItems.forEach(item => {
          item.values({
            checked: this.bulkCheckbox.checked ? 'checked' : ''
          });
        });
        this.list.update();
      } else {
        this.bulkCheckbox.indeterminate = false;
        this.bulkCheckbox.removeAttribute('indeterminate');

        // set check on all rows to match bulk checkbox state
        this.list.items.forEach(item => {
          item.values({
            checked: this.bulkCheckbox.checked ? 'checked' : ''
          });
        });
        this.list.update();
      }
    });
  }

  clickRowCheckbox(event) {
    const checkbox = event.target;
    const select = checkbox.getAttribute('data-bulk-select-row');
    const item = this.list.get('select', select)[0];
    item.values({
      checked: checkbox.checked ? 'checked' : ''
    });

    this.update();

    this.bulkCheckbox.dispatchEvent(new Event('change'));
  }

  update() {
    if (this.bulkCheckbox.getAttribute('indeterminate') !== 'indeterminate') {
      // set indeterminate check on bulk checkbox
      this.bulkCheckbox.indeterminate = true;
      this.bulkCheckbox.setAttribute('indeterminate', 'indeterminate');
      this.bulkCheckbox.checked = true;
      this.bulkCheckbox.setAttribute('checked', true);

      this.actions.removeClass(this.options.displayNoneClassName);
      this.replaced.addClass(this.options.displayNoneClassName);
    }

    // are all items now checked?
    if (
      this.list.items.every(i => {
        return i.values().checked === 'checked';
      })
    ) {
      this.bulkCheckbox.indeterminate = false;
      this.bulkCheckbox.removeAttribute('indeterminate');
    }
    // are all items now unchecked?
    if (
      this.list.items.every(i => {
        return i.values().checked !== 'checked';
      })
    ) {
      this.removeBulkCheck();
      this.actions.addClass(this.options.displayNoneClassName);
      this.replaced.removeClass(this.options.displayNoneClassName);
    }
  }

  removeBulkCheck() {
    this.bulkCheckbox.indeterminate = false;
    this.bulkCheckbox.removeAttribute('indeterminate');
    this.bulkCheckbox.checked = false;
    this.bulkCheckbox.setAttribute('checked', false);
  }

  toggleDisplay() {
    this.actions.toggleClass(this.options.displayNoneClassName);
    this.replaced.toggleClass(this.options.displayNoneClassName);
  }
}
